<div class="tw-flex tw-items-center tw-h-full tw-justify-end tw-gap-2">
  @if (showInfoIcon) {
    <button
      class="tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6 tw-shrink-0 tw-cursor-pointer tw-border-0 tw-p-0 tw-rounded-full tw-transition-all hover:tw-scale-110 hover:tw-opacity-80"
      [ngClass]="isExpanded ? 'tw-bg-color-status-warning-icon' : 'tw-bg-transparent'"
      (click)="toggleDetail($event)"
      [title]="'viewSavings' | i18n"
      [attr.aria-label]="'viewSavings' | i18n"
    >
      @if (isExpanded) {
        <svg width="18" height="18" viewBox="0 0 24 24" class="tw-text-color-text-on-dark">
          <use href="images/sprite.svg#info-tooltip-active" />
        </svg>
      } @else {
        <svg width="18" height="18" viewBox="0 0 24 24" class="tw-text-color-status-warning-icon">
          <use href="images/sprite.svg#info-tooltip" />
        </svg>
      }
    </button>
  }

  <div
    class="tw-flex tw-flex-col tw-items-end tw-justify-center tw-text-dt-text-headings tw-text-[13px] tw-leading-[125%]"
  >
    <span
      class="tw-font-medium"
      [ngClass]="{
        'tw-text-dt-text-in-primary': balanceDiff > 0,
        'tw-text-dt-text-out-primary': balanceDiff < 0,
        'tw-text-dt-text-secondary': balanceDiff === 0,
        '!tw-text-dt-text-secondary tw-font-normal': isBalanceAlignment,
      }"
      >{{ formattedBalanceDiff }}</span
    >

    <div class="tw-flex tw-text-dt-text-disabled tw-gap-1">
      <span>Bal.</span>
      <span [ngClass]="{ 'tw-text-dt-text-secondary': !isBalanceAlignment }">{{
        balance | number: "1.2-2"
      }}</span>
      <span [ngClass]="{ 'tw-text-dt-text-secondary': !isBalanceAlignment }">{{ symbol }}</span>
    </div>
  </div>
</div>
